module.exports = __webpack_public_path__ + "static/fonts/NanumSquareEB.0029b8a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareEB.woff
// module id = I2WF
// module chunks = 1